import { useState } from "react"
import { useSnackbar } from "../../../../context/popup";

export const useInsurerRegistryFormHandling = () => {

    const { showSnackbar } = useSnackbar();
    const [formData, setFormData] = useState({
        gInsurerId: "",
        products: [
            {
                gLobId: "",
                gProductId: "",
                gSubProductId: "",
                gVehicleCategoryId: "",
                isActive: true,
                environments: [
                    {
                        environmentId: "",
                        integrationStatusId: "",
                        onboardedAt: "",
                        notes: "",
                        isActive: true,
                    },
                ],
            },
        ],
        isActive: true,
        lastCheckedAt: "",
    });  

    const handleTopLevelChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleProductChange = (productIndex, field, value) => {
        setFormData((prev) => {
            const products = [...prev.products];

            products[productIndex] = {
            ...products[productIndex],
            [field]: value,
            };

            return { ...prev, products };
        });
    };

    const handleEnvironmentChange = (
        productIndex,
        envIndex,
        field,
        value
        ) => {
        setFormData((prev) => {
            const products = [...prev.products];
            const environments = [...products[productIndex].environments];

            environments[envIndex] = {
            ...environments[envIndex],
            [field]: value,
            };

            products[productIndex] = {
            ...products[productIndex],
            environments,
            };

            return { ...prev, products };
        });
    };

    const handleAddProduct = () => {
        setFormData((prev) => ({
            ...prev,
            products: [
            ...prev.products,
            {
                gLobId: "",
                gProductId: "",
                gSubProductId: "",
                gVehicleCategoryId: "",
                isActive: true,
                environments: [
                {
                    environmentId: "",
                    integrationStatusId: "",
                    onboardedAt: "",
                    notes: "",
                    isActive: true,
                },
                ],
            },
            ],
        }));
        showSnackbar("Product Added Successfully Below", "success");
    };

    const handleAddEnvironment = (productIndex) => {
        setFormData((prev) => {
            const products = [...prev.products];

            products[productIndex] = {
            ...products[productIndex],
            environments: [
                ...products[productIndex].environments,
                {
                environmentId: "",
                integrationStatusId: "",
                onboardedAt: "",
                notes: "",
                isActive: true,
                },
            ],
            };

            return { ...prev, products };
        });
        showSnackbar("Environment Added Successfully Below", "success");
    };


    const checkAllFields = () => {
        let allowSubmit = false;

        if (
        formData.gInsurerStatus === "success" &&
        formData.gLobIdStatus === "success" &&
        formData.gProductIdStatus === "success" &&
        formData.gSubProductIdStatus === "success" &&
        formData.gVehicleCategoryIdStatus === "success" &&
        formData.environmentStatus === "success" &&
        formData.integrationStatusStatus === "success" &&
        formData.onboardedAtStatus === "success"
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }

        return allowSubmit;
    };

    return{
        formData,
        setFormData,
        handleTopLevelChange,
        handleProductChange,
        handleEnvironmentChange,
        handleAddProduct,
        handleAddEnvironment,
        checkAllFields
    }
}